'use client';

import React from 'react';
import clsx from 'clsx';
import { Icons } from '@shared/ui';

interface CarouselNextButtonPropType {
    onClick: () => void;
    isPrevious?: boolean;
}

export const CarouselNextButton: React.FC<CarouselNextButtonPropType> = (props) => {
    const { onClick, isPrevious } = props;

    const NextIcon = isPrevious ? Icons.csr.ArrowLeft : Icons.csr.ArrowRight;

    const className = isPrevious ? 'carousel__previous-button' : 'carousel__next-button';

    return (
        <button className={clsx(className)} onClick={onClick}>
            <div className="carousel__button-bg" />
            <NextIcon className="carousel__button-icon" weight="bold" />
        </button>
    );
};
